import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { ContactUpdateMutation } from "./mutation";

import type { ContactUpdateInputZodSchemaType } from "../../schema";

export const useContactUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(ContactUpdateMutation);

	const updateContact = useCallback(
		async (contact: ContactUpdateInputZodSchemaType) => {
			return await mutationFunc({
				variables: {
					input: contact,
				},
			});
		},
		[mutationFunc],
	);

	return {
		updateContact,
	};
};
